import React, { memo } from 'react'
import { Handle } from '@xyflow/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faBuilding,
    faSquarePlus,
    faTrash,
    faUserPlus,
} from '@fortawesome/free-solid-svg-icons'

// تعریف نود جدید با دو ایکون
export const DepartmentNode = ({ data }) => {
    const { label, handlerAddPosition } = data

    return (
        <div className="departmentNode !bg-indigo-700 !shadow-2xl">
            <div className="departmentNode-label">{label}</div>
            <div className="departmentNode-box-icons">
                <span
                    onClick={handlerAddPosition}
                    className="departmentNode-position !text-white"
                >
                    <FontAwesomeIcon icon={faSquarePlus} />
                </span>
            </div>
            <Handle type="source" position="bottom" />
            <Handle type="target" position="top" />
        </div>
    )
}

export default memo(DepartmentNode)
